import { render, staticRenderFns } from "./PersonalNamePreview.vue?vue&type=template&id=394517dd&scoped=true&lang=html"
import script from "./PersonalNamePreview.vue?vue&type=script&lang=ts"
export * from "./PersonalNamePreview.vue?vue&type=script&lang=ts"
import style0 from "./PersonalNamePreview.vue?vue&type=style&index=0&id=394517dd&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394517dd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\ldemenego\\REPOS\\VUEJS\\configuratore-demenego-v2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('394517dd')) {
      api.createRecord('394517dd', component.options)
    } else {
      api.reload('394517dd', component.options)
    }
    module.hot.accept("./PersonalNamePreview.vue?vue&type=template&id=394517dd&scoped=true&lang=html", function () {
      api.rerender('394517dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PersonalNamePreview.vue"
export default component.exports